import { SERVER_API } from 'SharedDir/constants/app/endpoints';
import { IEndpointData } from 'SharedDir/declarations/shared';

export const newsUrl = `${SERVER_API}/news`;

export const ADMINISTRATION_NEWS = {
  PUBLISH(id: number): IEndpointData {
    return {
      method: 'PUT',
      url: `${newsUrl}/${id.toString()}/publish`,
    };
  },
  UNPUBLISH(id: number): IEndpointData {
    return {
      method: 'PUT',
      url: `${newsUrl}/${id.toString()}/unpublish`,
    };
  },
};
